<template>
  <SlottedDataChart v-model="counts" :refreshKey="modelId" :getDataFunction="() => getJobTypeUsageByModelId(modelId)" 
    :title="'Job type distribution last 12 months'">

    <template v-slot:chart="{ data }">
       <DxPieChart id="pie" :data-source="data" palette="Bright" :resolve-label-overlapping="'shift'"
          @point-click="pointClickHandler($event)" @legend-click="legendClickHandler($event)">
          <DxSeries argument-field="JobTypeName" value-field="JobCount">
            <DxLabel :visible="true" :customize-text="formatLabel" position="columns">
              <DxConnector :visible="true" :width="1" />
              <!-- <DxFont :size="16" />  -->
            </DxLabel>
          </DxSeries>

          <DxLegend :visible="true" :column-count="4" orientation="horizontal" item-text-position="right" 
            horizontal-alignment="center" :customize-text="formatLegend" vertical-alignment="top">
          </DxLegend>

          <!-- <DxSize :width="500" /> -->
          <!-- <DxExport :enabled="true" /> -->
        </DxPieChart>
    </template>
  </SlottedDataChart>
</template>


<script>
import ClientAPIMixin from '@/api/ClientAPIMixin';
import DxPieChart, {
  DxConnector,
  //DxExport,
  //DxFont,
  DxLabel,
  DxLegend,
  DxSeries,
} from 'devextreme-vue/pie-chart';
import SlottedDataChart from '@/views/pim/machinemodels/SlottedDataChart.vue';

export default {
  name: "MachineModelJobTypePieChart",
  props: {
    modelId: [Number, String],
  },
  components: {
    DxPieChart,
    //DxSize,
    DxSeries,
    DxLegend,
    //DxFont,
    DxLabel,
    DxConnector,
    //DxExport,
    SlottedDataChart,
  },
  mixins: [
    ClientAPIMixin,
  ],

  data() {
    return {
      counts: [],
    };
  },

  methods: { 
    formatLabel({ valueText, argumentText, percentText }) {
      return `${percentText} ${argumentText} (${valueText})`;
    },

    formatLegend(e) {
      var jobCount = this.counts[e.pointIndex]?.JobCount ?? 0;
      return `${jobCount} ${e.pointName}`;
    },

    toggleVisibility(item) {
      item.isVisible() ? item.hide() : item.show();
    },

    legendClickHandler(e) {
      console.log('legendClickHandler', e);
      const arg = e.target;
      const item = e.component.getAllSeries()[0].getPointsByArg(arg)[0];
      this.toggleVisibility(item);
      //this.openFailureCodePage(e.target.data.Id);
    },
    pointClickHandler(e) {
      console.log('pointClickHandler', e);
      this.toggleVisibility(e.target);
      //this.openFailureCodePage(e.target.data.Id);
    },

    openFailureCodePage(code) {
      this.$router.push({
        name: 'ViewFailureCode',
        params: { code: code },
      });
    },
   },

  computed: {},

  watch: {  },
};
</script>


<style lang='scss'></style>